import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {

  constructor(private dataService: DataService) { }

  getProviders(): Observable<any> {
    return this.dataService.getProviders();
  }

}
